module.exports = __webpack_public_path__ + "static/media/DE.56e87296.png";